// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: n4Ztyh1bnw
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicQ.module.css"; // plasmic-import: n4Ztyh1bnw/css
import OneSvgrepoComSvg2Icon from "./icons/PlasmicIcon__OneSvgrepoComSvg2"; // plasmic-import: YdKwW-dDKgL4/icon

createPlasmicElementProxy;

export const PlasmicQ__VariantProps = new Array();

export const PlasmicQ__ArgProps = new Array("children", "slot");

const $$ = {};

function PlasmicQ__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <OneSvgrepoComSvg2Icon
            className={classNames(projectcss.all, sty.svg__qhBhd)}
            role={"img"}
          />
        ),

        value: args.children
      })}
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        {renderPlasmicSlot({
          defaultContents: "Enter some text",
          value: args.slot,
          className: classNames(sty.slotTargetSlot)
        })}
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicQ__ArgProps,
          internalVariantPropNames: PlasmicQ__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicQ__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicQ";
  } else {
    func.displayName = `PlasmicQ.${nodeName}`;
  }
  return func;
}

export const PlasmicQ = Object.assign(
  // Top-level PlasmicQ renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicQ
    internalVariantProps: PlasmicQ__VariantProps,
    internalArgProps: PlasmicQ__ArgProps
  }
);

export default PlasmicQ;
/* prettier-ignore-end */
